/* eslint-disable */
import UserEvents from "./UserEvents";
import {UserList, UpdateUserList, User, UserItems, UserData, Auth, UserLogin } from "./User";


// ユーザー認証
// export const AuthnStart = () => ({
//     type: UserEvents.AuthnStart,
//} as const);
// export const AuthnComplete = (user: UserData) => ({
//     type: UserEvents.AuthnComplete,
//     user
//} as const);
export const AuthnStart = (email:any, mttms: any) => ({
    type: UserEvents.AuthnStart,
    email, mttms
} as const);
export const AuthnComplete = (user: UserData) => ({
    type: UserEvents.AuthnComplete,
    user
} as const);

// ログインユーザー情報取得
export const LoginStarted = (email: string) => ({
    type: UserEvents.LoginStarted,
    email
} as const);
export const AuthStarted = (userAuth: Auth) => ({
    type: UserEvents.AuthStart,
    userAuth
} as const);
export const AuthComplete = (email: string) => ({
    type: UserEvents.AuthComplete,
    email
} as const);
export const LoginComplete = (user: UserData) => ({
    type: UserEvents.LoginComplete,
    user
} as const);
export const SignOut = () => ({
    type: UserEvents.SignOut,
} as const);

//ユーザー一覧取得
export const GetUserInfoList= ()=> ({
    type: UserEvents.GetUserInfoListStarted
} as const);

export const GetUserInfoListComplete = (listItems: UserList[]) => ({
    type: UserEvents.GetUserInfoListComplete,
    listItems
} as const);

// ユーザ一覧更新
export const UpdateUserInfo= (updateListItems: UpdateUserList[])=> ({
    type: UserEvents.UpdateUserInfoStarted,
    updateListItems
} as const);

export const UpdateUserInfoComplete = (listItems: UserList[]) => ({
    type: UserEvents.UpdateUserInfoComplete,
    listItems
} as const);

export const UpdateUserInfoFailed = () => ({
    type: UserEvents.UpdateUserInfoFailed
} as const);

// ユーザ一プロファイル画像更新
export const UpdateUserProfileImage= (imageFile: any, profileItems: UserItems)=> ({
    type: UserEvents.UpdateUserProfileImageStarted,
    imageFile,
    profileItems,
} as const);

export const UpdateUserProfileImageComplete = (user: User) => ({
    type: UserEvents.UpdateUserProfileImageComplete,
    user
} as const);
export const UpdateUserProfileImageFailed = () => ({
    type: UserEvents.UpdateUserProfileImageFailed
} as const);

//スキル一覧取得
export const GetSkillList= (inputSkillList: string[])=> ({
    type: UserEvents.GetSkillListStarted,
    inputSkillList
} as const);

export const GetSkillListComplete = (outputSkillList: string[]) => ({
    type: UserEvents.GetSkillListComplete,
    outputSkillList
} as const);

// ユーザー情報更新バッチを手動実行
export const StartSyncBatch = () => ({
    type: UserEvents.StartSyncBatch,
} as const);
export const StartSyncBatchComplete = () => ({
    type: UserEvents.StartSyncBatchComplete,
} as const);
export const StartSyncBatchFailed = (error: string) => ({
    type: UserEvents.StartSyncBatchFailed,
    error
} as const);

// トークン検証
export const ValidateTokenStarted = (accessToken: string, userLogin: UserLogin) => ({
  type: UserEvents.ValidateSSOTokenStarted,
  accessToken,
  userLogin
} as const);

export const ValidateTokenSuccess = (user: UserData) => ({
  type: UserEvents.ValidateSSOTokenSuccess,
  user,
} as const);

export const ValidateTokenFailure = (error: string) => ({
  type: UserEvents.ValidateSSOTokenFailure,
  error,
} as const);

